import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Row, Col, Form, Button, Alert } from 'reactstrap';
import Recaptcha from 'react-recaptcha';

import { getAll, AddCustomersMessages, addCustomersThreads } from '../actions/contactsActions';

class ContactsNous extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idContact: 1,
      email: null,
      emailContact: null,
      message: null,
      recaptchaVerified: false,
      sending: false, // Nouvel état pour suivre l'état d'envoi
    };
    this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
  }

  recaptchaLoaded() {
    console.log('Recaptcha loaded successfully');
  }

  verifyCallback(response) {
    if (response) {
      this.setState({ recaptchaVerified: true });
    }
  }

  componentDidMount() {
    let { getAll } = this.props;
    getAll();
  }

  change = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const [selectedId, selectedEmail] = selectedValue.split(' ');
    this.setState({ idContact: selectedId, emailContact: selectedEmail });
  };

  submit = (e) => {
    e.preventDefault();

    let { AddCustomersMessages } = this.props;
    let { addCustomersThreads } = this.props;

    const formData = {
      idContact: this.state.idContact,
      emailContact: this.state.emailContact,
      email: this.state.email,
      message: this.state.message,
    };

    if (this.state.recaptchaVerified) {
      this.setState({ sending: true }); // Indiquer que l'envoi est en cours
      AddCustomersMessages(formData);
      addCustomersThreads(formData)
        .then(() => {
          this.setState({ sending: false }); // Revenir à l'état initial après l'envoi
        })
        .catch(() => {
          this.setState({ sending: false }); // Revenir à l'état initial en cas d'erreur d'envoi
        });
    } else {
      this.setState({ recaptchaVerified: false });
    }
  };

  render() {
    let { data, message, thread } = this.props.contacts;

    return (
      <div>
        <Container className="mb-4">
          {thread.checkThread === 1 && message.checkMessage ? (
            <Alert color="success" className="my-4 mx-4 text-center px-4 py-4">
              Votre message a bien été envoyé à notre équipe.
            </Alert>
          ) : (
            <Row>
              <Col xs="12" md="6" lg="6">
                <Form onSubmit={this.submit} id="form-data" className="my-4">
                  <select
                    className="form-control"
                    name="idContact"
                    onChange={this.handleSelectChange}
                  >
                    {data &&
                      data.map((item, key) => (
                        <option value={`${item.id} ${item.email}`} key={key}>
                          {item.name[0].value}
                        </option>
                      ))}
                  </select>
                  <input
                    type="email"
                    className="form-control email my-2"
                    id="email"
                    name="email"
                    placeholder="Votre e-mail ..."
                    onChange={this.change}
                    required
                  />
                  <textarea
                    className="form-control message my-2"
                    cols="5"
                    rows="10"
                    id="message"
                    name="message"
                    onChange={this.change}
                    placeholder="Comment pouvons-nous aider ?"
                  ></textarea>
                  <Recaptcha
                    sitekey="6LcP5z4pAAAAAIDhHElH--sdYuF-7iJBaZTgnSME"
                    render="explicit"
                    onloadCallback={this.recaptchaLoaded}
                    verifyCallback={this.verifyCallback}
                    hl="fr"
                  />
                  <Button color="primary" className="mt-2" disabled={this.state.sending}>
                    {this.state.sending ? 'Envoi en cours...' : 'ENVOYER'}
                  </Button>
                  {thread.checkThread === 2 && message.checkMessage ? (
                    <Alert color="danger" className="my-4 mx-4 text-center px-4 py-4">
                      Problème envoi mail!
                    </Alert>
                  ) : null}
                </Form>
              </Col>
              <Col xs="12" md="6" lg="6" className="coordonnee">
                <h2 className="tile-page mb-4" data-aos="fade-up">
                  <strong>Coordonnées</strong>
                </h2>
                <iframe
                  src="https://maps.google.com/maps?&q=paris-france&output=embed"
                  width="500"
                  height="450"
                  style={{ border: "0" }}
                  title="Carte"
                />
              </Col>
            </Row>
          )}
        </Container>
      </div>
    );
  }
}

function mapStateToProps({ contactsReducer }) {
  return {
    contacts: contactsReducer,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getAll: bindActionCreators(getAll, dispatch),
    AddCustomersMessages: bindActionCreators(AddCustomersMessages, dispatch),
    addCustomersThreads: bindActionCreators(addCustomersThreads, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactsNous);



// WEBPACK FOOTER //
// ./src/components/ContactsNous.js